import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OurTeam from "../components/Hcomp/OurTeam";
import TourFacility from "../components/Hcomp/TourFacility";
import { FaAnglesDown } from "react-icons/fa6";

const Aboutpage = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);
  const lineClamp = isExpanded ? "" : "line-clamp-[13]";

  // show arrow state
  const [showArrow, setShowArrow] = useState(true);

  // hide arrow on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowArrow(false);
      window.removeEventListener("scroll", handleScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // smooth scroll if URL has hash (#tour-facility etc.)
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <section>
      {/* Hero Banner */}
      {/* <div
        style={{
          backgroundImage: "url(./assets/bmt/about_us_bg.jpg)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="h-[50vh] md:h-screen relative p-14 mt-24"
      >
        <img
          src="/assets/bmt/sfcn_luth_logo.png"
          alt="bmt-logo"
          className="px-[25px] md:px-0 absolute top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 mb-14 w-[500px] h-auto"
        />
        <div className="hidden w-full absolute bottom-36 z-50 lg:flex items-center justify-center">
          {showArrow && (
            <FaAnglesDown className="text-4xl text-white/80 shadow-md bounce-animation rounded-full font-extralight" />
          )}
        </div>
      </div> */}

      {/* <div
        style={{
          backgroundImage: "url(./assets/bmt/about_us_bg.jpg)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="h-[50vh] md:h-screen relative mt-24 flex items-center justify-center"
      >
        DARK GRADIENT OVERLAY FOR LEGIBILITY
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="absolute inset-0 bg-primary_red/30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/20"></div>

        PREMIUM GLASS PANEL BEHIND LOGO
        <div className="relative z-20 px-6 py-4 rounded-2xl backdrop-blur-md bg-white/10 shadow-2xl border border-white/20">
          <img
            src="/assets/bmt/sfcn_luth_logo.png"
            alt="bmt-logo"
            className="w-[260px] sm:w-[350px] md:w-[420px] lg:w-[500px] h-auto mx-auto"
          />
        </div> */}

      {/* SCROLL DOWN ICON */}
      {/* {showArrow && (
          <div className="absolute bottom-12 z-30 flex items-center justify-center animate-bounce">
            <FaAnglesDown className="text-4xl text-white/80 drop-shadow-lg" />
          </div>
        )} */}
      {/* </div> */}

      <div
        style={{
          backgroundImage: "url(./assets/bmt/about_us_bg.jpg)",
        }}
        className="relative h-[65vh] md:h-screen mt-24 bg-cover bg-center bg-no-repeat overflow-hidden"
      >
        {/* DARK CINEMATIC OVERLAY */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/40 to-black/20 z-[1]"></div>

        {/* CINEMATIC ZOOM */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0 animate-[slowzoom_18s_ease-in-out_infinite]"
          style={{
            backgroundImage: "url(./assets/bmt/about_us_bg.jpg)",
            filter: "brightness(0.9)",
          }}
        ></div>

        {/* ATMOSPHERIC LIGHT STREAK (PREMIUM TOUCH) */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-[streak_10s_linear_infinite] z-[2]"></div>

        {/* ✨ NEW — GLASS SHADE BEHIND LOGO (RESTORED) */}
        {/* <div
          className="
            absolute left-1/2 top-1/2 z-[4]
            transform -translate-x-1/2 -translate-y-1/2
            px-10 py-6 rounded-3xl
            backdrop-blur-xl bg-black/25 
            shadow-2xl border border-white/20
            animate-[panelFade_6s_ease-in-out_infinite]
          "
        > */}
        {/* ✨ LOGO WITH SOFT BLEND INTO BACKGROUND */}
        {/* <img
            src="/assets/bmt/sfcn_luth_logo.png"
            alt="bmt-logo"
            className="
              w-[240px] sm:w-[320px] md:w-[400px] lg:w-[480px] h-auto 
              opacity-[0.10] 
              mix-blend-screen 
              drop-shadow-[0_0_30px_rgba(255,255,255,0.25)]
              animate-[logoPulse_8s_ease-in-out_infinite]
            "
          />
        </div> */}

        {/* ✨ NEW — GLASS SHADE BEHIND LOGO (RESTORED) */}
        <div
          className="
            absolute left-1/2 top-1/2 z-[4]
            transform -translate-x-1/2 -translate-y-1/2
            px-8 py-1 rounded-3xl
            backdrop-blur-xl bg-black/25 
            shadow-2xl border border-white/20
            animate-[panelFade_6s_ease-in-out_infinite]
          "
        >
          {/* ✨ TWO LOGOS WITH VERTICAL DIVIDER */}
          <div className="flex items-center gap-4">
            {/* FIRST LOGO */}
            <img
              src="./assets/bmt/scfn_logo2.PNG"
              alt="luth logo"
              className="
                w-[90px] sm:w-[90px] md:w-[120px] lg:w-[140px] 
                opacity-[0.12] mix-blend-screen
                drop-shadow-[0_0_30px_rgba(255,255,255,0.25)]
                animate-[logoPulse_8s_ease-in-out_infinite]
              "
            />

            {/* VERTICAL DIVIDER */}
            <div className="h-[70px] sm:h-[70px] md:h-[90px] lg:h-[90px] w-[2px] bg-white/40 rounded-full" />

            {/* SECOND LOGO */}
            <img
              src="./assets/bmt/luth_logo2.PNG"
              alt="sfcn logo"
              className="
                w-[80px] sm:w-[80px] md:w-[80px] lg:w-[80px]
                opacity-[0.12] mix-blend-screen
                drop-shadow-[0_0_30px_rgba(255,255,255,0.25)]
                animate-[logoPulse_8s_ease-in-out_infinite]
              "
            />
          </div>
        </div>

        {/* SCROLL ARROW */}
        {showArrow && (
          <div className="absolute bottom-16 z-[5] flex items-center justify-center w-full animate-bounce">
            <FaAnglesDown className="text-4xl text-white/85 drop-shadow-xl" />
          </div>
        )}

        {/* PREMIUM CURVED BOTTOM */}
        <div className="absolute bottom-0 left-0 w-full h-[110px] bg-white rounded-t-[80px] translate-y-[40%] z-[3]"></div>
      </div>

      {/* About Content */}
      <section className="flex flex-col lg:flex-row items-center justify-center gap-1 w-full px-[25px] lg:px-14">
        {/* Left Image */}
        <div className="m-10 w-full lg:w-1/2 md:px-10 lg:px-0">
          <img
            src="/assets/bmt/treatment_team.jpg"
            alt="Aboutpage Our BMT"
            width={547}
            height={649}
            className="w-full"
          />
        </div>

        {/* Right Text */}
        <div className="w-full lg:w-1/2 block h-max lg:h-[670px] my-auto pt-[40px] md:px-10 lg:px-0 cursor-pointer overflow-y-auto">
          <p className={lineClamp}>
            <span className="w-full text-[17px] font-[300] font-lexend text-primary_dark leading-tight mt-4 text-justify lg:text-start">
              <span className="capitalize font-bold text-primary_tomato_red block text-[26px] mb-2">
                SCFN | LUTH | VUMC Partnership
              </span>
              Stem Cell Transplantation or Bone Marrow Transplantation (BMT) is
              the known cure for sickle cell disorder. Sickle Cell Foundation
              Nigeria (SCFN) and Lagos University Teaching Hospital (LUTH) have
              partnered to establish a BMT Programme in Lagos, in order that
              excellent quality, safe, affordable and life-changing cure for
              sickle cell disorder will be locally available and accessible to
              Nigerians in Nigeria. This is indeed fitting as Nigeria is by far
              the country with the highest burden of sickle cell disorder in the
              world. Over 40 million Nigerians are carriers of the sickle cell
              gene and an estimated 150,000 babies are born every year with
              sickle cell in the country. Sadly, 100,000 of these babies do not
              live to celebrate their 5th birthday – dying mostly from ignorance
              and lack of access to proper diagnosis, treatment and care.
              <span>
                <span className="font-[700] text-primary_red block my-5">
                  Our BMT Journey:
                </span>
                Our BMT journey started in 2011 when SCFN and LUTH partnered
                with the Mediterranean Institute of Haematology (IME) Rome and
                nearly 50 Nigerian children travelled to Italy and received free
                BMT. However, the programme was abruptly terminated due to
                funding challenges in Italy.
              </span>
              <br />
              <br />
              <span>
                <span className="font-[700] text-primary_red text-justify lg:text-start">
                  The Tripartite Partnership for BMT:
                </span>
                <br />
                Following the cessation of our BMT project with IME Rome, SCFN
                and LUTH commenced initial discussions with Vanderbilt
                University Medical Center (VUMC) in 2017, culminating in the
                formalisation of partnership with the institution via an MoU in
                2020 with VUMC as technical partners, for the establishment of
                our own BMT Centre in Lagos, Nigeria.
              </span>
              <br />
              <br />
              <span>
                The centre is a state-of-the-art facility and it will be the
                first-ever, comprehensive BMT centre for Sickle Cell Disease in
                Sub-Saharan Africa.
              </span>
              <br />
              <br />
              <span>
                A Public-Private-Partnership, our BMT programme brings
                excellent, quality, safe and affordable cure for sickle cell
                disorder to Nigerians and Africans.
              </span>
              <br />
              <br />
              <span>
                The SCFN/LUTH BMT Centre was officially opened in January 2022
                and it will serve as a Centre of Excellence for BMT training and
                service provision.
              </span>
              <br />
              <br />
              <span>
                Be a part of this laudable programme. <br />
                <Link
                  to="/donation"
                  className="font-bold text-primary_tomato_red hover:underline"
                >
                  DONATE NOW.
                </Link>
              </span>
            </span>
          </p>

          <button
            className="font-bold text-primary_red cursor-pointer inline mt-5"
            onClick={toggleExpand}
          >
            {!isExpanded ? "Read more" : "See Less"}
          </button>
        </div>
      </section>

      {/* Tour Facility Section with ID for hash navigation */}
      <section id="tour-facility">
        <TourFacility />
      </section>

      {/* Team Section */}
      <OurTeam />
    </section>
  );
};

export default Aboutpage;
